import { take } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { MoveToStepComponent } from '../move-to-step/move-to-step.component';
import { VisaDesignerService } from '../visa-designer.service';
import { select, Store } from '@ngrx/store';
import * as fromVDTask from '../vd-state/reducers/vd.reducer';
import { PdfStepPreviewComponent } from '../pdf-step-preview/pdf-step-preview.component';
import { combineLatest } from 'rxjs';
import * as moment from 'moment';
import { getDataSourceCountryList, SetDataSourceCountryList } from 'visa-store';
import { ReferenceLibraryService } from 'reference-library';
@Component({
  selector: 'app-vd-builder-build-steps',
  templateUrl: './vd-builder-build-steps.component.html',
  styleUrls: ['../visa-designer.scss', './vd-builder-build-steps.component.scss'],
  providers: [DialogService]
})
export class VdBuilderBuildStepsComponent implements OnInit {

  visaId: any;
  selectedObjArray: any[] = [];
  pdfList: any[] = [];
  columnWidth = [
    { value: null, label: 'Select' },
    { value: 12, label: 'Full page width' },
    { value: 8, label: 'Two-third page width' },
    { value: 6, label: 'Half page width' },
    { value: 4, label: 'One-third page width' },
  ];
  fromYear: string;
  toYear: string;
  visaInfo: any;
  countryList: any[];
  isView: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private visaDesignerService: VisaDesignerService,
    private store: Store<any>,
    private referenceLibraryService: ReferenceLibraryService
  ) {
    this.toYear = moment().add(5, 'years').format('YYYY');
    this.fromYear = moment().subtract(5, 'years').format('YYYY');
    this.getCountry();
  }

  ngOnInit(): void {
    combineLatest([
      this.store.select(fromVDTask.getVDVisaId),
      this.store.select(fromVDTask.getVDVisaInfo)
    ])
      .pipe(take(1))
      .subscribe(([visaId, visaInfo]) => {
        this.visaId = visaId;
        this.visaInfo = visaInfo;
        if (this.visaId) {
          this.buildDataFunction();
        } else {
          this.router.navigate(['../../../../manage-visa/created-visas'], { relativeTo: this.route });
        }
      });
      this.route.params.subscribe((params) => {
        this.isView = (params['isView'] === 'view') ? true : false;
      }); 
  }

  getSelectedObjectsInSteps() {
    this.visaDesignerService.getUsedObjectsFromVisaPDFtoWorkflow(this.visaId)
      .pipe(take(1))
      .subscribe((response: any) => {
        this.pdfList = this.visaDesignerService.segregateUsedAndUnusedElements(this.pdfList, response);
      });
  }

  buildDataFunction() {
    const isOld = ['RELFFORMERSEC191', 'SUSPDPRT881'].includes(this.visaInfo && this.visaInfo.immClassification ? this.visaInfo.immClassification.code : '');
    combineLatest([
      isOld ?
        this.visaDesignerService.oldTempJSONFunc(this.visaId) :
        this.visaDesignerService.tempJSONFunc(this.visaId),
      this.visaDesignerService.getUsedObjectsFromVisaPDFtoWorkflow(this.visaId)
    ])
      .pipe(take(1))
      .subscribe((response: any[]) => {
        if (response[0]) {
          if (isOld) {
            this.pdfList = this.visaDesignerService.oldVdPdfEngine(response[0], response[1]);
          } else {
            this.pdfList = this.visaDesignerService.newVdPdfEngine(response[0], response[1]);
          }
        } else {
          this.pdfList = [];
        }
      });
  }

  getTotalColUsed(row: number): number {
    return this.selectedObjArray
      .filter(x => x.numberOfRow === row)
      .reduce((a, b) => a + (b.numberOfColumn || 0), 0);
  }

  getMaxRowValue() {
    return this.selectedObjArray && this.selectedObjArray.length > 0 ? Math.max(...((this.selectedObjArray.map(x => x.numberOfRow)) as number[])) : 1;
  }

  onChecked(element: any) {
    if (element.checked) {
      if (!(this.selectedObjArray &&
        this.selectedObjArray.some(x => x.elementId === element.elementId))) {
        const maxRowValue = this.getMaxRowValue();
        if (!element.numberOfRow && !element.numberOfColumn) {
          const totalCol = this.getTotalColUsed(maxRowValue);
          if ((totalCol + 4) > 12) {
            element.numberOfRow = maxRowValue + 1;
            element.numberOfColumn = 4;
          } else {
            element.numberOfRow = maxRowValue;
            element.numberOfColumn = 4;
          }
        } else {
          let row = element.numberOfRow ? element.numberOfRow : maxRowValue;
          let totalCol = this.getTotalColUsed(row);
          if (element.numberOfColumn) {
            if ((totalCol + element.numberOfColumn) <= 12) {
              element.numberOfRow = row;
            } else {
              if (row === maxRowValue) {
                element.numberOfRow = row + 1;
              } else {
                totalCol = this.getTotalColUsed(maxRowValue);
                if ((totalCol + element.numberOfColumn) <= 12) {
                  element.numberOfRow = maxRowValue;
                } else {
                  element.numberOfRow = maxRowValue + 1;
                }
              }
            }
          } else {
            if (row > maxRowValue) {
              element.numberOfRow = row;
              element.numberOfColumn = 4;
            } else if (row === maxRowValue) {
              element.numberOfRow = row + 1;
              element.numberOfColumn = 4;
            } else {
              row = maxRowValue;
              totalCol = this.getTotalColUsed(row);
              if ((totalCol + 4) > 12) {
                element.numberOfRow = row + 1;
                element.numberOfColumn = 4;
              } else {
                element.numberOfRow = row;
                element.numberOfColumn = 4;
              }
            }
          }
        }
        this.selectedObjArray.push(element);
      }
    } else if (this.selectedObjArray &&
      this.selectedObjArray.some(x => x.elementId === element.elementId)) {
      const ele = this.selectedObjArray.find(x => x.elementId === element.elementId);
      ele.numberOfRow = null;
      ele.numberOfColumn = null;
      this.selectedObjArray.splice(this.selectedObjArray.findIndex(x => x.elementId === element.elementId), 1);
    }

    // const jsonBuildToTimeline = this.selectedObjArray.map(x => {
    //   return {
    //     ...x.defaultProperties,
    //     numberOfRow: x.numberOfRow,
    //     numberOfColumn: x.numberOfColumn
    //   };
    // });
    // this.visaDesignerService.buildStepsSelectedData = jsonBuildToTimeline;

    // var xxx = this.selectedObjArray;
  }

  nextStep() {
    // const jsonBuildToTimeline = this.selectedObjArray.map(x => {
    //   return {
    //     ...x.defaultProperties,
    //     numberOfRow: x.numberOfRow,
    //     numberOfColumn: x.numberOfColumn
    //   };
    // });
    // this.visaDesignerService.buildStepsSelectedData = jsonBuildToTimeline;
    if(this.isView){
      this.router.navigate([`../../timeline-steps/view`], { relativeTo: this.route });
    }else{
      this.router.navigate([`../timeline-steps`], { relativeTo: this.route });
    }
    
  }

  moveToStep() {
    const buildStepsSelectedData = this.selectedObjArray.map(x => {
      return {
        ...x.defaultProperties,
        numberOfRow: x.numberOfRow ? x.numberOfRow : 0,
        numberOfColumn: x.numberOfColumn ? x.numberOfColumn : 4
      };
    });
    const ref = this.dialogService.open(MoveToStepComponent, {
      header: 'Move Fields To A New Step',
      width: '70%',
      styleClass: 'move-to-step-popup',
      data: {
        buildStepsSelectedData
      }
    });
    ref.onClose.subscribe((response: any) => {
      if (response && response.moved) {
        this.getSelectedObjectsInSteps();
      }
    });
  }

  previewStep() {
    const payload = JSON.parse(JSON.stringify(this.selectedObjArray)).map(x => {
      if (x.stateList) {
        x.stateList = [];
      }
      return x;
    });
    const ref1 = this.dialogService.open(PdfStepPreviewComponent, {
      header: 'Step Name',
      width: '70%',
      styleClass: 'pdf-preview-step-popup',
      data: payload
    });

  }

  getCountry() {
    this.store.pipe(select(getDataSourceCountryList))
      .pipe(take(1))
      .subscribe((data: any[]) => {
        if (data && data.length > 0) {
          data.unshift({
            name: 'Select',
            code: null
          });
          this.countryList = data;
        } else {
          this.referenceLibraryService.getDataSource('COUNTRY', '')
            .pipe(take(1))
            .subscribe((response: any[]) => {
              if (response) {
                this.countryList = JSON.parse(JSON.stringify(response));
                this.countryList.unshift({
                  name: 'Select',
                  code: null
                });
              } else {
                this.countryList = [];
              }
              this.store.dispatch(new SetDataSourceCountryList(response || null));
            });
        }
      });
  }

  handleCountryChange(evt, element) {
    let countryCode = evt.value;
    this.referenceLibraryService.getStatesFromStore(countryCode)
      .pipe(take(1))
      .subscribe((states: any[]) => {
        if (states) {
          states.unshift({
            stateProvinceName: 'Select',
            stateProvinceCode: null
          });
          element.stateList = states;
        } else {
          this.referenceLibraryService.getStatesFromApi(countryCode)
            .pipe(take(1))
            .subscribe((data: any[]) => {
              if (data) {
                data.unshift({
                  stateProvinceName: 'Select',
                  stateProvinceCode: null
                });
                element.stateList = data;
              } else {
                element.stateList = [];
              }
            });
        }
      });
  }

}
